module.exports = __webpack_public_path__ + "img/inflatableBlueContact.9dc9e7da.svg";